import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];
const reveal = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.15 },
  transition: { duration: 0.7, ease: EASE },
};

const PILLARS = [
  {
    n: "01",
    t: "Sobrecarga Progressiva Real",
    d: "O músculo só cresce se houver um motivo para isso. O foco é a evolução constante de carga, técnica e controle em cada movimento.",
  },
  {
    n: "02",
    t: "Exercícios Base e Movimentos Compostos",
    d: "Agachamentos, supinos, remadas e levantamentos são os alicerces. O grosso do resultado vem de dominar os pilares da força.",
  },
  {
    n: "03",
    t: "Intensidade com Execução Impecável",
    d: "Carga sem controle é convite para lesão. Buscamos a falha real, mas mantendo o padrão biomecânico perfeito em todas as repetições.",
  },
  {
    n: "04",
    t: "Individualidade Biológica",
    d: "Não existe protocolo engessado. A periodização é desenhada de acordo com a sua rotina, sua resposta de recuperação e seus pontos fracos.",
  },
];

export default function About() {
  return (
    <section id="sobre" className="section-pad border-t border-white/10">
      <div className="container-x grid gap-12 lg:grid-cols-12 lg:gap-16">
        {/* Foto */}
        <motion.div {...reveal} className="lg:col-span-5">
          <div className="lg:sticky lg:top-24">
            <div className="glow-white lg:mr-6 lg:mb-6">
              <div className="clip-corner overflow-hidden border border-white/15">
                <img
                  src="/about-lf.jpg"
                  alt="LF Team — treinador, foto em preto e branco"
                  className="aspect-[3/4] w-full object-cover"
                />
              </div>
            </div>
          </div>
        </motion.div>

        {/* Texto */}
        <div className="lg:col-span-7">
          <motion.div {...reveal}>
            <p className="overline-label">Lucas Fucht · 25 anos</p>
            <h2 className="h2-display mt-4 text-white">
              Quem <span className="text-stroke">sou eu.</span>
            </h2>
          </motion.div>

          <motion.div
            {...reveal}
            className="mt-7 flex flex-col gap-4 text-base leading-relaxed text-white/65 md:text-lg"
          >
            <p>
              Meu nome é Lucas Fucht, tenho 25 anos e sou formado em Educação
              Física, cursando pós-graduação em Bodybuilding Coach. Sou
              apaixonado por musculação e pelo fisiculturismo raiz — treino há
              mais de 6 anos, e minha trajetória é guiada pela busca incessante
              por evolução física, unindo a paixão pelos treinos intensos à
              fundamentação acadêmica.
            </p>
            <p>
              Acredito que o verdadeiro trabalho de um treinador vai muito
              além de passar uma ficha de exercícios: é sobre entender a
              individualidade de cada aluno, ajustar a rota com base em dados
              e construir uma mentalidade forte. Aqui, o compromisso é com o
              seu progresso real, sem atalhos ou fórmulas mágicas.
            </p>
          </motion.div>

          <motion.div {...reveal} className="mt-14">
            <h3 className="font-display text-3xl font-black uppercase tracking-tight text-white md:text-4xl">
              Minha filosofia <span className="text-stroke">de treino.</span>
            </h3>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-white/60 md:text-base">
              O treinamento de alta performance não precisa ser complexo
              demais, mas precisa ser inteligente, pesado e consistente. Minha
              metodologia é construída sobre pilares inegociáveis:
            </p>
          </motion.div>

          <div className="mt-8 grid gap-3 sm:grid-cols-2">
            {PILLARS.map((p, i) => (
              <motion.div
                key={p.n}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.15 }}
                transition={{ duration: 0.6, delay: i * 0.07, ease: EASE }}
                className="border border-white/10 bg-card p-6 transition-colors duration-300 hover:border-white/30"
              >
                <p className="font-mono text-[11px] tracking-[0.3em] text-white/40">
                  {p.n}
                </p>
                <h4 className="mt-3 font-display text-xl font-black uppercase tracking-tight text-white md:text-2xl">
                  {p.t}
                </h4>
                <p className="mt-3 text-sm leading-relaxed text-white/60">
                  {p.d}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
